
















import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import cookieMixin from '@/mixins/cookie';

@Component
export default class MultipleCheckBox extends mixins(cookieMixin) {
  @Prop() private name!: string;
  @Prop() private value!: string;
  @Prop() private id!: string;
  @Prop() private namespace!: string;
  @Prop() private state!: string;
  @Prop() private label_class?: string;

  created() {
    const plan = this.$store.getters['hikari/phonePlan'];
    if (plan === this.payload.id) {
      this.checkedData = this.findArray(this.payload);
      this.saveStatus();
    }
  }

  get payload() {
    return { id: this.name };
  }

  get checkedData() {
    return this.$store.getters[`${this.namespace}/${this.state}`];
  }
  set checkedData(value: string[]) {
    this.$store.commit(`${this.namespace}/${this.state}`, value);
  }

  private saveStatus(): void {
    this.saveValue(this.payload, JSON.stringify(this.checkedData));
  }
}
